import React, {useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { useSettings } from '../context/SettingsContext'
import { Nav } from './partials/Nav';

const Reports = () => {
  useEffect(() => {
    document.title = 'Reports | ValParx Admin'
  }, []);

  const reports = [
    {
      title: 'General Sales Report',
      path: '/reports/sales',
      description: 'View sales and transaction data by lot'
    },
    {
      title: 'Transaction Breakdown by Lot',
      path: '/reports/transactions',
      description: 'View detailed transaction list for a specific lot'
    }
  ];

  return (
    <div className='min-h-screen flex items-start justify-center py-12 px-4 sm:px-6 lg:px-8'>
      <Nav />
      <div className="max-w-5xl w-full space-y-8 pt-20">
        <div className='flex justify-between items-center mb-12'>
          <h2 className='mb-0'>Reports</h2>
        </div>
        
        <ul id='reports' className={`w-full max-w-2xl mx-auto`}>
          {reports.map((report, index) => (
            <li key={index} className="mb-2">
              <Link to={report.path} className="uppercase py-1 font-bold flex justify-between items-center bg-gray-100 rounded-lg p-2">
                <span className='overflow-x-clip text-gray-900'>{report.title}</span>
                <FontAwesomeIcon icon="fa-arrow-right fa-solid" className='mr-2 text-sm text-accent' />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Reports;
